module.exports = __webpack_public_path__ + "img/index-loadTeacher.6ba6d384.jpg";